namespace TabAurous.Common {
    export enum MartialStatus {
        Married = 1,
        Unmarried = 2,
        Divorced = 3,
        Widowed = 4
    }
    Serenity.Decorators.registerEnumType(MartialStatus, 'TabAurous.Common.MartialStatus', 'HR.MartialStatus');
}
